export function formatDuration(millis: number): string {
  if (!Number.isFinite(millis) || millis < 0) {
    return '-';
  }

  const totalSeconds = Math.floor(millis / 1000);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  const days = Math.floor(hours / 24);

  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days} d`);
  }
  if (hours % 24 > 0) {
    parts.push(`${hours % 24} h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} min`);
  }
  if (seconds > 0 || parts.length === 0) {
    parts.push(`${seconds} s`);
  }

  return parts.join(' ');
}
